import { BackgroundVariant, MarkerType } from "@xyflow/react";
import { Edge } from "~/routes/process/-components/canvas/edge";

export const nodeTypes = {
  STEP: "step",
  STAGE: "stage",
  BRANCH: "branch",
  TRIGGER: "trigger",
  MANUAL_TRIGGER: "manual",
} as const;

export const edgeTypeMapping = {
  default: Edge,
} as const;

export const STAGE_Z_INDEX = 1000;
export const EDGE_Z_INDEX_ABOVE_STAGES = STAGE_Z_INDEX + 1;
export const CONNECTION_RADIUS = 40;
export const DEFAULT_EDGE_OPTIONS = {
  zIndex: EDGE_Z_INDEX_ABOVE_STAGES,
  markerEnd: {
    type: MarkerType.Arrow,
    color: "currentColor",
    height: 25,
    width: 25,
  },
};

// Canvas zoom limits
export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 2;

export const BACKGROUND_VARIANT = BackgroundVariant.Dots;
export const DEFAULT_BACKGROUND_COLOR = "var(--canvas-background)";
export const BACKGROUND_OPTIONS = {
  bgColor: DEFAULT_BACKGROUND_COLOR,
  variant: BACKGROUND_VARIANT,
  gap: 12,
  size: 1,
};

export const FIXED_STEP_WIDTH = 300;
export const DEFAULT_STAGE_PADDING = {
  horizontal: 100,
  top: 150,
  bottom: 50,
};
export const MIN_STEP_HEIGHT = 80;

// Fixed layout settings for consistent node heights
export const FIXED_STEP_HEIGHT = 170;
export const BRANCH_NODE_SIZE = 94;
export const TRIGGER_NODE_SIZE = 94;

// Edge constants
export const ID_PREFIX_FOR_BRANCH_EDGES = "branch_";

export const DEFAULT_STAGE_WIDTH = FIXED_STEP_WIDTH * 2;
export const DEFAULT_STAGE_HEIGHT = FIXED_STEP_HEIGHT * 2;

export const ZOOM_DETAIL_MAPPING = [
  { threshold: 0.3, level: "minimum-detail" },
  { threshold: 0.5, level: "low-detail" },
  { threshold: 0.7, level: "detailed" },
  { threshold: Infinity, level: "super-detailed" },
] as const;

/**
 * Width of the library panel in pixels (matches --sidebar-width CSS variable)
 */
export const LIBRARY_PANEL_WIDTH = 320;

/**
 * Width of the chat panel in pixels (matches --sidebar-width CSS variable)
 */
export const CHAT_PANEL_WIDTH = 400;

/**
 * Padding between steps in a stage when they are being dragged over each other
 */
export const STEP_PADDINGS = {
  horizontal: 100,
  vertical: 50,
};

/**
 * Vertical spacing between nodes in ELK auto-layout
 */
export const AUTO_LAYOUT_NODE_SPACING = 200;

/**
 * Amount that padding on each side of a stage increases when a node is being dragged over it during drag-and-drop
 */
export const STAGE_PADDING_INCREASE_ON_DND_HOVER = 5;

// Tolerance threshold - if node is within this distance, snap it inside instead of expanding stage
export const SNAP_TOLERANCE = 30;

export const DEFAULT_STEP_PROVIDER = "core";
